import React from "react"
import { BrowserRouter as Router } from "react-router-dom"
import { useSelector } from "react-redux"

import Header from "./shared/header"
import Footer from "./shared/footer"
import AppRouter from "./appRouter"
import { IRedux } from "./services/types"

const App = () => {
  const loading = useSelector((state: IRedux) => state.loading.is)

  return (
    <div className="container">
      <div className={`pageloader ${loading && "is-active"}`}>
        <span className="title">Chargement</span>
      </div>
      <Router>
        <Header />
        <div style={{ margin: "20px 0", padding: "0 10px", width: "100%" }}>
          <AppRouter />
        </div>
        <Footer />
      </Router>
    </div>
  )
}

export default App
